<mat-menu #actionMenu="matMenu">
    <button mat-menu-item (click)="logout()">Logout</button>
</mat-menu>

<ng-container *ngIf="!customize">
    <ig-button *ngIf="!isUserLoggedWithFacebook&&!isQuadrate&&!isSmallest" (trigger)="login()" class="dark-blue-btn">
        <img class="facebook-logo" [src]="fbLogo" alt="facebook logo">
        <ng-container *ngIf="!isSmallPC&&!isMobile&&!isExSmallMobile">Log in With FB</ng-container>
        <ng-container *ngIf="(isSmallPC||isMobile)&&!isExSmallMobile">Log in</ng-container>
    </ig-button>

    <ig-button *ngIf="!isUserLoggedWithFacebook&&isQuadrate&&!isSmallest" (trigger)="login()">
        <span style="margin-left: 0" *ngIf="!text" class="text-logo">f</span>
        <span style="margin-left: 8px">{{text||'Log in'}}</span>
    </ig-button>

    <ig-button *ngIf="!isUserLoggedWithFacebook&&isSmallest" (trigger)="login()" class="smallest-btn">
        <span style="margin-left: 0" *ngIf="!text" class="text-f">f</span>
    </ig-button>
</ng-container>

<div *ngIf="customize" (click)="login()">
    <ng-content></ng-content>
</div>

<img #profileImg *ngIf="isUserLoggedWithFacebook" [matMenuTriggerFor]="actionMenu" [src]="profilePicture" alt="facebook user profile">


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/facebook.login.button/facebook.login.button.component.html